(function () {
  var MAX_ATTEMPTS = 60;
  var INTERVAL_MS = 250;

  function formatReviews() {
    var reviewsContainer = document.querySelector('.product-info-and-media__reviews');
    if (!reviewsContainer) return;

    var ratingTextEl = reviewsContainer.querySelector('.product-info-and-media__rating-text');
    if (!ratingTextEl) return;

    var label = ratingTextEl.getAttribute('data-rating-label') || 'AVERAGE RATING';

    var attempts = 0;

    var poll = setInterval(function () {
      attempts++;

      var okeRating = reviewsContainer.querySelector('.oke-sr-rating');
      var okeCount = reviewsContainer.querySelector('.oke-sr-count');
      var okeStars = reviewsContainer.querySelector('.oke-sr-stars');
      var metafieldScript = reviewsContainer.querySelector('script[data-oke-metafield-data]');

      var avg = 0;
      var count = 0;
      var dataFound = false;

      if (okeStars) {
        if (okeRating) {
          avg = parseFloat(okeRating.textContent.trim());
        }
        if (okeCount) {
          var countText = okeCount.textContent.trim();
          var countMatch = countText.replace(/,/g, '').match(/(\d+)/);
          if (countMatch) {
            count = parseInt(countMatch[1], 10);
          }
        }
        if (!avg && okeStars) {
          var ariaLabel = okeStars.getAttribute('aria-label') || '';
          var ariaMatch = ariaLabel.match(/([\d.]+)\s*out of/i);
          if (ariaMatch) {
            avg = parseFloat(ariaMatch[1]);
          }
        }
        if (avg > 0) {
          dataFound = true;
        }
      }

      if (!dataFound && metafieldScript) {
        try {
          var raw = metafieldScript.textContent.trim();
          var data = JSON.parse(raw);
          avg = parseFloat(data.averageRating);
          count = parseInt(data.reviewCount, 10);
          if (avg > 0) {
            dataFound = true;
          }
        } catch (e) {}
      }

      if (dataFound && avg > 0) {
        clearInterval(poll);
        reviewsContainer.classList.remove('product-info-and-media__reviews--pending');

        ratingTextEl.textContent = '';

        var avgSpan = document.createElement('span');
        avgSpan.className = 'product-info-and-media__rating-avg';
        avgSpan.textContent = avg.toFixed(1);

        var labelSpan = document.createElement('span');
        labelSpan.className = 'product-info-and-media__rating-label';
        labelSpan.textContent = ' ' + label + ' ';

        var countSpan = document.createElement('span');
        countSpan.className = 'product-info-and-media__rating-count';
        countSpan.textContent = '(' + count.toLocaleString() + ')';

        ratingTextEl.appendChild(avgSpan);
        ratingTextEl.appendChild(labelSpan);
        ratingTextEl.appendChild(countSpan);
        ratingTextEl.style.display = '';

        var nativeRating = reviewsContainer.querySelector('.oke-sr-rating');
        var nativeCount = reviewsContainer.querySelector('.oke-sr-count');
        if (nativeRating) nativeRating.style.display = 'none';
        if (nativeCount) nativeCount.style.display = 'none';

        var srEl = reviewsContainer.querySelector('.oke-sr');
        if (srEl) {
          srEl.classList.remove('oke-sr--hidden');
        }

        return;
      }

      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(poll);
        ratingTextEl.style.display = 'none';
      }
    }, INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatReviews);
  } else {
    formatReviews();
  }
})();
